import React, { useEffect, useState } from "react";
import { StyledShopName, StyledTopPart } from "../Catalog/styled";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import Resume from "./Resume";
import ErrorPage from "../../components/common/ErrorPage/ErrorPage";
import Beneficiarie from "./Beneficiarie";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import { colors } from "../../theme/colors";
import Pay from "./Pay";
import { ModalBox } from "./styled";
import { HighlightOffOutlined } from "@mui/icons-material";
import Result from "./Result";
import { getInitials, px2Rem } from "../../utils/functions";
import PageLoader from "../../components/common/PageLoader/PageLoader";

export default function Buy() {
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState();
  const [errorLoading, setErrorLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [clientInfo, setClientInfo] = useState({
    beneficiarie: {
      name: "",
      surname: "",
      phone: "",
      email: "",
    },
    payment: {
      cardNumber: "",
      cardHolder: "",
      expDate: "",
      cvv: "",
    },
    taxpayer: {
      nit: "",
      phone: "",
      email: "",
    },
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [paying, setPaying] = useState(false);
  const [errorPaying, setErrorPaying] = useState(0);
  const [modalButtonHover, setModalButtonHover] = useState(false);
  const [searchParams, _] = useSearchParams();
  const [payingResult, setPayingResult] = useState({});
  const [ipError, setIpError] = useState(false);

  const updateBeneficiarie = (beneficiarie) => {
    setClientInfo({ ...clientInfo, beneficiarie });
  };

  const nextStep = () => {
    window.scrollTo(0, 0);
    setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 0) {
      window.scrollTo(0, 0);
      setStep(step - 1);
    }
  };

  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_BE_SERVICE}/oky/product?p=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.errorCode === "403") {
          console.log("entre aca");
          setIpError(true);
        } else {
          if (
            res.minimumAmount > parseInt(searchParams.get("va")) ||
            res.maximumAmount < parseInt(searchParams.get("va"))
          ) {
            window.scrollTo(0, 0);
            navigate("../");
          } else {
            setProduct(res);
            setLoading(false);
          }
        }
      })
      .catch((err) => {
        setErrorLoading(true);
        setLoading(false);
      });
  }, []);

  const executePayment = (values) => {
    setModalOpen(true);
    setPaying(true);
    setErrorPaying(null);

    setClientInfo({
      ...clientInfo,
      payment: values.payment,
      taxpayer: values.taxpayer,
    });

    const sendValues = {
      ...clientInfo,
      payment: values.payment,
      taxpayer: values.taxpayer,
      productId: id,
    };

    if (product.productType === "RANGE_AMOUNT") {
      sendValues.voucherAmount = searchParams.get("va");
    }

    fetch(`${process.env.REACT_APP_BE_SERVICE}/ebi/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(sendValues),
    })
      .then((paymentResult) => paymentResult.json())
      .then((paymentResult) => {
        // PRODUCT NOT FOUND
        if (paymentResult.transaction.code === 0) {
          setErrorPaying(4);
          setPaying(false);
        }

        // TRANSACTION DECLINED
        else if (paymentResult.transaction.code === 1) {
          setErrorPaying(0);
          setPaying(false);
        }

        // OKY error EBI transaction completed
        else if (paymentResult.transaction.code === 2) {
          fetch(`${process.env.REACT_APP_BE_SERVICE}/ebi/cancel`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              auditNumber: paymentResult.ebi.data.audit_number,
              token: paymentResult.ebi.data.token,
            }),
          })
            .then((revertResult) => revertResult.json())
            .then((revertResult) => {
              setErrorPaying(5);
              setModalOpen(true);
              setPaying(false);
            });
        } else if (paymentResult.transaction.code === 4) {
          setErrorPaying(1);
          setPaying(false);
        } else {
          setPayingResult(paymentResult);
          setModalOpen(false);
          setPaying(false);
          nextStep();
        }
      })
      .catch((err) => {
        // FETCH ERROR
        setErrorPaying(4);
        setModalOpen(true);
        setPaying(false);
      });
  };

  if (ipError) {
    return (
      <>
        <Modal open="true">
          <ModalBox>
            <HighlightOffOutlined color="error" style={{ fontSize: "5rem" }} />
            <Typography
              variant="h2"
              sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
            >
              Usuario inhabilitado temporalmente
            </Typography>

            <Typography variant="body1" color="primary">
              Las solicitudes con este usuario no están disponibles en este
              momento.
            </Typography>
          </ModalBox>
        </Modal>
      </>
    );
  }

  if (loading) {
    return (
      <>
        <StyledTopPart height="180px"></StyledTopPart>
        <PageLoader />
      </>
    );
  }

  if (errorLoading) {
    return <ErrorPage />;
  }

  return (
    <Box sx={{ wordWrap: "break-word" }}>
      <StyledTopPart height="180px"></StyledTopPart>

      <>
        {" "}
        <Typography
          variant="h2"
          sx={{
            color: colors.white.main,
            position: "absolute",
            top: "calc(25px - 25px + 200px)",
            left: "calc(50vw)",
            transform: "translateX(-50%)",
            textAlign: "center",
            width: "100%",
            "@media screen and (max-width: 600px)": {
              fontSize: "1.5rem",
              top: "calc(25px + 200px)",
            },
          }}
        >
          {product.partner}
        </Typography>
        {product.brandImage ? (
          <Avatar
            sx={{
              width: 91,
              height: 91,
              position: "absolute",
              top: "calc(100px - 25px + 200px)",
              left: "calc(50vw - 45px)",
              outline: `10px ${colors.white.main} solid`,
            }}
            src={product.brandImage}
          />
        ) : (
          <StyledShopName
            style={{
              width: 91,
              height: 91,
              position: "absolute",
              top: "calc(100px - 25px + 200px)",
              left: "calc(50vw - 45px)",
              outline: `10px ${colors.white.main} solid`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span>{getInitials(product.partner)}</span>
          </StyledShopName>
        )}
      </>

      {step === 0 && (
        <Resume
          product={product}
          nextStep={nextStep}
          va={searchParams.get("va")}
        />
      )}
      {step === 1 && (
        <Beneficiarie
          prevStep={prevStep}
          nextStep={nextStep}
          beneficiarie={clientInfo.beneficiarie}
          updateBeneficiarie={updateBeneficiarie}
        />
      )}
      {step === 2 && (
        <Pay
          product={product}
          prevStep={prevStep}
          nextStep={nextStep}
          executePayment={executePayment}
          va={searchParams.get("va")}
          beneficiarie={clientInfo.beneficiarie}
        />
      )}

      {step === 3 && (
        <Result
          product={product}
          beneficiarie={clientInfo.beneficiarie}
          result={payingResult}
          va={searchParams.get("va")}
        />
      )}

      <Modal open={modalOpen}>
        <ModalBox>
          {paying && (
            <>
              <CircularProgress />
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
              >
                Procesando...
              </Typography>
            </>
          )}

          {errorPaying === 0 && (
            <>
              <HighlightOffOutlined
                color="error"
                style={{ fontSize: "5rem" }}
              />
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
              >
                Transacción Rechazada
              </Typography>

              <Typography variant="body1" color="primary">
                La transacción falló por datos incorrectos, falta de fondos o
                límite de transacciones alcanzados. Verifica y vuelve a
                intentarlo. <br /> <br />
                Por seguridad esta plataforma de pago no almacenará ninguna
                información de su tarjeta, ni datos personales.
              </Typography>

              <Button
                onMouseOver={() => setModalButtonHover(true)}
                onMouseOut={() => setModalButtonHover(false)}
                variant={modalButtonHover ? "outlined" : "contained"}
                color={modalButtonHover ? "primary" : "secondary"}
                onClick={() => setModalOpen(false)}
              >
                Volver a Intentar
              </Button>

              <Typography
                variant="body2"
                color="secondary"
                sx={{
                  textDecoration: "underline",
                  fontSize: "1rem",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("../");
                }}
              >
                Cancelar compra
              </Typography>
            </>
          )}

          {errorPaying === 1 && (
            <>
              <HighlightOffOutlined
                color="error"
                style={{ fontSize: "5rem" }}
              />
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
              >
                Denegada
              </Typography>

              <Typography variant="body1" color="primary">
                Por seguridad esta plataforma de pago no almacenará ninguna
                información de su tarjeta, ni datos personales.
              </Typography>

              <Button
                onMouseOver={() => setModalButtonHover(true)}
                onMouseOut={() => setModalButtonHover(false)}
                variant={modalButtonHover ? "outlined" : "contained"}
                color={modalButtonHover ? "primary" : "secondary"}
                onClick={() => setModalOpen(false)}
              >
                Volver a Intentar
              </Button>

              <Typography
                variant="body2"
                color="secondary"
                sx={{
                  textDecoration: "underline",
                  fontSize: "1rem",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
              >
                Cancelar compra
              </Typography>
            </>
          )}

          {errorPaying === 4 && (
            <>
              <HighlightOffOutlined
                color="error"
                style={{ fontSize: "5rem" }}
              />
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
              >
                Error de conexión
              </Typography>

              <Typography variant="body1" color="primary">
                Por seguridad esta plataforma de pago no almacenará ninguna
                información de su tarjeta, ni datos personales.
              </Typography>

              <Button
                onMouseOver={() => setModalButtonHover(true)}
                onMouseOut={() => setModalButtonHover(false)}
                variant={modalButtonHover ? "outlined" : "contained"}
                color={modalButtonHover ? "primary" : "secondary"}
                onClick={() => setModalOpen(false)}
              >
                Volver a Intentar
              </Button>

              <Typography
                variant="body2"
                color="secondary"
                sx={{
                  textDecoration: "underline",
                  fontSize: "1rem",
                  fontWeight: "bold",
                }}
                onClick={() => navigate("../")}
              >
                Cancelar compra
              </Typography>
            </>
          )}

          {errorPaying === 5 && (
            <>
              <HighlightOffOutlined
                color="error"
                style={{ fontSize: "5rem" }}
              />
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
              >
                El vale no está disponible en este momento
              </Typography>

              <Typography variant="body1" color="primary">
                Por seguridad esta plataforma de pago no almacenará ninguna
                información de su tarjeta, ni datos personales.
              </Typography>

              <Typography
                variant="body2"
                color="secondary"
                sx={{
                  textDecoration: "underline",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  "&:hover": {
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                }}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("../");
                }}
              >
                Regresar al inicio
              </Typography>
            </>
          )}

          {errorPaying === 6 && (
            <>
              <HighlightOffOutlined
                color="error"
                style={{ fontSize: "5rem" }}
              />
              <Typography
                variant="h2"
                sx={{ fontSize: { xs: px2Rem(32), md: px2Rem(40) } }}
              >
                Bloqueado
              </Typography>

              <Typography variant="body1" color="primary">
                Tu ip ha sido bloqueada
              </Typography>

              <Typography
                variant="body2"
                color="secondary"
                sx={{
                  textDecoration: "underline",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  "&:hover": {
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                }}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("../");
                }}
              >
                Regresar al inicio
              </Typography>
            </>
          )}
        </ModalBox>
      </Modal>
    </Box>
  );
}
